module.exports = __webpack_public_path__ + "img/Bedroom01.1503be44.png";